<template>
  <textarea 
    :value="value" 
    @input="$emit('input', $event.target.value)"
    ref="input" />
</template>

<script>
export default {
  name: "FormTextarea",
  props: {
    value: {
      default: "",
      type: String
    }
  },
   mounted(){
    this.$refs.input.focus();
   }
}
</script>

<style lang="scss" scoped>
  textarea {
    min-height: 15vh;
  }
</style>